import { getUrl, downloadData, uploadData, list as s3List } from 'aws-amplify/storage';
import { ConsoleLogger } from 'aws-amplify/utils';
import { awsconfig } from '../../Const';

type GetOptions = {
  bucket?: string | { bucketName: string; region: string };
  download?: boolean;
  contentType?: string;
};

type PutOptions = {
  bucket?: string | { bucketName: string; region: string };
  contentType?: string;
};

type ListOptions = {
  level?: 'public' | 'protected' | 'private';
};

const logger = new ConsoleLogger("amplifyStorageCompat.ts")

function resolveBucketOption(bucket?: string | { bucketName: string; region: string }) {
  if (!bucket) return undefined;
  if (typeof bucket === 'string') {
    return { bucketName: bucket, region: awsconfig.aws_user_files_s3_bucket_region } as any;
  }
  return bucket as any;
}

export const Storage = {
  async get(key: string, options?: GetOptions): Promise<any> {
    logger.debug("get key = ", key, " options = ", options)
    if (options?.download) {
      try {
      const downloadResult= await downloadData({ path: key, options: { bucket: resolveBucketOption(options.bucket) }}).result;
        const text = await downloadResult.body.text();
        logger.info("download successful, text = ", text)
        return { Body: downloadResult.body };
      } catch (error) {
        logger.error("error downloading data: ", error)
        throw error
      }
    } else {
      const urlResp: any = await getUrl({ path: key, options: { bucket: resolveBucketOption(options?.bucket) }});
      logger.debug("urlResp = ", urlResp)
      const href = (urlResp && typeof urlResp === 'object' && 'url' in urlResp) ? (urlResp as any).url?.toString?.() : urlResp?.toString?.();
      return href || String(urlResp);
    }
  },
  
  async list(prefix: string, options?: ListOptions): Promise<any[]> {
    logger.debug("list prefix = ", prefix)
    const resp: any = await s3List({ prefix, options: { level: options?.level } as any });
    const items: any[] = resp?.items ?? resp?.results ?? resp ?? [];
    return items.map((it: any) => ({ key: it?.key ?? it }));
  },
};


